/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/
import { Pipe, PipeTransform } from '@angular/core';
import { faAddressBook, faArrowRight, faCheck, faStar } from '@fortawesome/pro-regular-svg-icons';
import { TaskStatus } from '../../enums/task-status.enum';

@Pipe({
  name: 'taskStatusIcon',
  standalone: false
})
export class TaskStatusIconPipe implements PipeTransform {
  transform(taskStatus: TaskStatus): any {
    switch (taskStatus) {
      case TaskStatus.NEW:
        return faStar;
      case TaskStatus.IN_PROGRESS:
        return faArrowRight;
      case TaskStatus.CLOSED:
        return faCheck;
      default:
        return faAddressBook;
    }
  }
}
